import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNow } from "../../utils";
import { Title } from "../../components/NewTitle";

export const HomeConnection = () => {
  const { t } = useTranslation();
  return (
    <div className="home-connection">
      <div className="inner">
        <Title title={t("home.connection.title")} size="h1">
          {t("home.connection.subtitle")}
        </Title>
        <div className="home-connection-img">
          <img
            src="//files.authing.co/authing-website/home-conection-v2.png"
            alt="身份安全"
          />
        </div>
      </div>
    </div>
  );
};
